import { CHAPTERS } from "@/data/site";
import { Overline, Reveal } from "@/components/motion";

const ChapterBlock = ({ chapter, flip }) => (
  <div
    className={`grid grid-cols-1 items-center gap-10 md:grid-cols-12 ${
      flip ? "" : ""
    }`}
  >
    <Reveal className={`md:col-span-5 ${flip ? "md:order-2 md:col-start-8" : ""}`}>
      <div className="group relative overflow-hidden border border-white/5">
        <div className="aspect-[4/3] overflow-hidden">
          <img
            src={chapter.image}
            alt={chapter.alt}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-108"
          />
        </div>
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-stone-950/50 to-transparent" />
      </div>
    </Reveal>
    <Reveal
      delay={0.12}
      className={`md:col-span-6 ${flip ? "md:order-1 md:col-start-1" : "md:col-start-7"}`}
    >
      <span className="block font-serif text-7xl leading-none text-hollow md:text-8xl">
        {chapter.number}
      </span>
      <h3 className="mt-4 font-serif text-3xl tracking-tight text-stone-100 md:text-4xl">
        {chapter.title}
      </h3>
      <p className="mt-5 max-w-lg text-base font-light leading-relaxed text-stone-400 md:text-lg">
        {chapter.body}
      </p>
    </Reveal>
  </div>
);

const Story = () => (
  <section
    id="story"
    data-testid="story-section"
    className="relative border-t border-white/5 bg-stone-900/30 py-28 md:py-36"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-20">
        <Overline>Our Story</Overline>
        <h2 className="mt-5 max-w-2xl font-serif text-4xl leading-[1.05] tracking-tight text-stone-100 sm:text-5xl lg:text-6xl">
          A manifesto in <em className="not-italic text-amber-500">three leaves</em>
        </h2>
        <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-stone-400 md:text-lg">
          Garden, fire, and your table. Everything Amber Brew does is written in these three
          chapters — and re-read with every cup.
        </p>
      </Reveal>

      <div className="space-y-24 md:space-y-32">
        {CHAPTERS.map((c, i) => (
          <ChapterBlock key={c.number} chapter={c} flip={i % 2 === 1} />
        ))}
      </div>
    </div>
  </section>
);

export default Story;
